import CustomMarkdown from '@/molecules/CustomMarkdown';
import { useCmsData } from 'utils/cms';

const RgpdDisclaimer = () => {
  const {
    generalSettings: { rgpdDisclaimer },
  } = useCmsData();

  return rgpdDisclaimer && <CustomMarkdown className="text-xs text-neutral-900">{rgpdDisclaimer}</CustomMarkdown>;
};

export default RgpdDisclaimer;
